/**
 * Dashboard Skeleton Components
 * ダッシュボード各コンポーネントのスケルトン表示
 * シマーローディングエフェクト対応
 */

import { Card, SimpleGrid, Stack, Group, Skeleton } from '@mantine/core';
import RLSkeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { glassStyle } from '../styles/glassmorphism';

export const EnhancedKpiCardsSkeleton = () => {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
      {[1, 2, 3, 4].map((i) => (
        <Card
          key={i}
          padding="lg"
          radius="sm"
          shadow="sm"
          style={{
            ...glassStyle,
            background: 'rgba(255, 255, 255, 0.5)',
            backdropFilter: 'blur(16px)',
          }}
        >
          <Group justify="space-between" mb="xs">
            <Stack gap={4}>
              <RLSkeleton width={120} height={12} baseColor="#e0e0e0" highlightColor="#f5f5f5" />
              <RLSkeleton width={80} height={28} baseColor="#e0e0e0" highlightColor="#f5f5f5" />
            </Stack>
            <RLSkeleton
              circle
              width={56}
              height={56}
              baseColor="#e0e0e0"
              highlightColor="#f5f5f5"
            />
          </Group>
          <RLSkeleton
            height={40}
            style={{ marginTop: 8 }}
            baseColor="#e0e0e0"
            highlightColor="#f5f5f5"
          />
        </Card>
      ))}
    </SimpleGrid>
  );
};

export const CheckInOutTabsSkeleton = () => {
  return (
    <Card padding="lg" radius="sm" shadow="sm" style={glassStyle}>
      <Stack gap="md">
        <Skeleton height={40} width="100%" />
        <Stack gap="xs">
          {[1, 2, 3, 4].map((i) => (
            <Skeleton key={i} height={60} width="100%" />
          ))}
        </Stack>
      </Stack>
    </Card>
  );
};

export const WeeklyComparisonChartSkeleton = () => {
  return (
    <Card padding="lg" radius="sm" shadow="sm" style={glassStyle}>
      <Stack gap="md">
        <Skeleton height={24} width="50%" />
        <Skeleton height={300} width="100%" />
      </Stack>
    </Card>
  );
};

export const TodayScheduleGanttSkeleton = () => {
  return (
    <Card padding="lg" radius="sm" shadow="sm" style={glassStyle}>
      <Stack gap="md">
        <Skeleton height={24} width="40%" />
        <Skeleton height={200} width="100%" />
      </Stack>
    </Card>
  );
};

export const AttendanceTrendChartSkeleton = () => {
  return (
    <Card padding="lg" radius="sm" shadow="sm" style={glassStyle}>
      <Stack gap="md">
        <Skeleton height={24} width="40%" />
        <Skeleton height={300} width="100%" />
      </Stack>
    </Card>
  );
};
